import { auth } from "./firebase.service";

export const getBearerToken = async (): Promise<string> => {
  if (auth?.currentUser) {
    const response = await auth?.currentUser?.getIdToken();
    return `Bearer ${response}`;
  } else {
    return Promise.reject("User not logged in, hence cannot get token");
  }
};
